class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.product_tab_results = document.getElementById('product-default-results');
    this.searchButton = document.getElementById('searchDrawer');
    this.journal_tab_results = document.getElementById('journal-default-results');
    this.predictiveSearchResultsDiv = document.getElementById('shopify-section-predictive-search-main');
    this.predictiveSearchResultsArticle = document.getElementById('shopify-section-predictive-search-articles');
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.searchButton.addEventListener('click', this.onChange.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }


  onChange() {
   
    this.product_tab_results.classList.add('hidden')
    this.journal_tab_results.classList.add('hidden')
    this.predictiveSearchResultsDiv.classList.remove('hidden')
    this.predictiveSearchResultsArticle.classList.remove('hidden')
    super.onChange();
    this.searchTerm = this.getQuery();

    if (!this.searchTerm.length) {
      this.close(true);
      this.product_tab_results.classList.remove('hidden')
      this.journal_tab_results.classList.remove('hidden')
      this.predictiveSearchResultsDiv.classList.add('hidden')
      this.predictiveSearchResultsArticle.classList.add('hidden')
      return;

    }

    this.getSearchResults(this.searchTerm);
    this.getSearchResultsArticle(this.searchTerm);
  }

  onFormSubmit(event) {
   
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      //this.open();
    } else {
      this.getSearchResults(this.searchTerm);
      this.getSearchResultsArticle(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  hideSpinner(){
    let svg = document.getElementsByClassName('predictive-search__loading-state')
    for (var x = 0; x < svg.length; x++) {
      if(!svg[x].classList.contains('hidden')){
        svg[x].classList.add('hidden')
      }
    }
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&resources[type]=product&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }
  getSearchResultsArticle(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&resources[type]=article&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResultsArticle(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
   //this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.predictiveSearchResultsDiv.innerHTML = resultsMarkup;
  
   this.setAttribute('results', true);
  
    this.setLiveRegionResults();
    this.hideSpinner();
    this.renderLabels();
    //this.open();
  }

  renderSearchResultsArticle(resultsMarkup) {
    this.predictiveSearchResultsArticle.innerHTML = resultsMarkup;
  
    this.setAttribute('results', true);
    
    this.setLiveRegionResults();
    this.hideSpinner();
    //this.open();
  }


  setLiveRegionResults() {
    this.removeAttribute('loading');
    //this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  renderLabels(){
    let allColors = document.querySelectorAll('.colorlist label')
    var getData = function() {
      
        var parent = this.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
        var get_selector = parent.getAttribute("data-selector");
        var get_color = this.getAttribute('data-opt-color')
        var handle = parent.getAttribute("data-product-handle");
        let size_selector =  document.querySelector('[data-selector="' + get_selector + '"][data-product-handle="' + handle + '"] [data-color-sizes="' + get_color + '"]')
        let price_selector = document.querySelector('[data-selector="' + get_selector + '"][data-product-handle="' + handle + '"] [data-color-price="' + get_color + '"]')
        let title_selector =  document.querySelector('[data-selector="' + get_selector + '"][data-product-handle="' + handle + '"] [data-color-title="' + get_color + '"]')
        let img_selector = document.querySelector('[data-selector="' + get_selector + '"][data-product-handle="' + handle + '"] [data-color-imgs="' + get_color + '"]')
        let selectedAttr =  document.querySelector('[data-selector="' + get_selector + '"][data-product-handle="' + handle + '"] [data-opt-color-selected="1"]')

        var actives = parent.querySelectorAll('.active');
        [].forEach.call(actives, function(elem) {  
            elem.classList.remove("active");
        });
    

        if(size_selector) size_selector.classList.add('active')
        if(price_selector) price_selector.classList.add('active')
        if(title_selector) title_selector.classList.add('active')
        if(img_selector) img_selector.classList.add('active')
        if(selectedAttr) selectedAttr.setAttribute('data-opt-color-selected', '0')
        this.setAttribute('data-opt-color-selected', '1')
    };
    for (var i = 0; i < allColors.length; i++) {
    allColors[i].addEventListener('click', getData, false);
    }
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    console.log("close",13);
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);